module.exports = __webpack_public_path__ + "images/emoji/ear_of_rice.7f4cc1993afb913c6c91.png";